import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-red-600' : 'text-gray-700 hover:text-red-600';
  };
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-99">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-100">
        <Link to="/" className="flex items-center" data-id="element-101">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oJdan4WMDEFTY4whDvxtiq/001.png" alt="Daplamba Investments Limited Logo" className="h-16" data-id="element-102" />
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-103">
          <Link to="/" className={`font-medium ${isActive('/')}`} data-id="element-104">
            Home
          </Link>
          <Link to="/about" className={`font-medium ${isActive('/about')}`} data-id="element-105">
            About Us
          </Link>
          <Link to="/services" className={`font-medium ${isActive('/services')}`} data-id="element-106">
            Services
          </Link>
          <Link to="/projects" className={`font-medium ${isActive('/projects')}`} data-id="element-107">
            Projects
          </Link>
          <Link to="/contact" className={`font-medium ${isActive('/contact')}`} data-id="element-108">
            Contact
          </Link>
        </nav>
        {/* Contact Button */}
        <div className="hidden md:block" data-id="element-109">
          <Link to="/contact" className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md font-medium transition-colors" data-id="element-110">
            Get a Quote
          </Link>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-111">
          {isMenuOpen ? <XIcon size={24} data-id="element-112" /> : <MenuIcon size={24} data-id="element-113" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white py-4 px-4 shadow-lg" data-id="element-114">
          <nav className="flex flex-col space-y-4" data-id="element-115">
            <Link to="/" className={`font-medium ${isActive('/')}`} onClick={() => setIsMenuOpen(false)} data-id="element-116">
              Home
            </Link>
            <Link to="/about" className={`font-medium ${isActive('/about')}`} onClick={() => setIsMenuOpen(false)} data-id="element-117">
              About Us
            </Link>
            <Link to="/services" className={`font-medium ${isActive('/services')}`} onClick={() => setIsMenuOpen(false)} data-id="element-118">
              Services
            </Link>
            <Link to="/projects" className={`font-medium ${isActive('/projects')}`} onClick={() => setIsMenuOpen(false)} data-id="element-119">
              Projects
            </Link>
            <Link to="/contact" className={`font-medium ${isActive('/contact')}`} onClick={() => setIsMenuOpen(false)} data-id="element-120">
              Contact
            </Link>
            <Link to="/contact" className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md font-medium transition-colors text-center" onClick={() => setIsMenuOpen(false)} data-id="element-121">
              Get a Quote
            </Link>
          </nav>
        </div>}
    </header>;
};
export default Header;